// extracted by mini-css-extract-plugin
export default {"carouselItem":"index-module__carouselItem___gG+3R","cardContent":"index-module__cardContent___melv3","designerCarousel":"index-module__designerCarousel___zZIhr"};